import React from 'react';
import { Dialog } from 'src/components/dialog';
import { LongTermContent } from 'src/components/long-term-content';
import { LearnMoreContainer } from 'src/components/v2/learn-more-container';

interface Props {
  onCloseAfter?: () => void;
  isShow: boolean;
  onClose: (action: 'cross' | 'inactive zone' | 'continue') => void;
}

export const PopupLearnMoreLongTermPlans = ({
  isShow,
  onClose,
  onCloseAfter,
}: Props) => {
  return (
    <Dialog
      isShow={isShow}
      onClose={() => onClose('inactive zone')}
      onCloseAfter={onCloseAfter}
    >
      <LearnMoreContainer>
        <LongTermContent
          onContinue={() => onClose('continue')}
          onClose={() => onClose('cross')}
        />
      </LearnMoreContainer>
    </Dialog>
  );
};
